export default __webpack_public_path__ + "static/media/version-control.4127e851.svg";